import { Tag } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const TagInLabel = styled(Tag)`
    margin-top: -2px;
`;
